import React from "react";
import BeneficariesView from "../BeneficariesView/BeneficariesView";
import Icon1 from "../../images/gbrFarmerBenefits/pay-per-click.svg";

// Component for Maintenance Engineers 
const MaintenanceEngineer = () => {
  // Features available for Maintenance Engineers
  const features = [
    {
      image: Icon1,
      title: "Predictive Maintenance Alerts",
      bodycopy:
        "AI-driven monitoring to predict failures and reduce unexpected breakdowns.",
    },
    {
      image: Icon1,
      title: "Equipment Health Dashboard",
      bodycopy:
        "Real-time insights into machinery performance, maintenance history, and efficiency tracking.",
    },
    {
      image: Icon1,
      title: "Automated Work Order Management",
      bodycopy:
        "Digitized maintenance schedules, task assignments, and progress tracking.",
    },
    {
      image: Icon1,
      title: "Remote Diagnostics & Support",
      bodycopy:
        "IoT-enabled systems allow remote troubleshooting and issue resolution.",
    },
    {
      image: Icon1,
      title: "Spare Parts & Inventory Management",
      bodycopy:
        "Seamless tracking of spare parts availability and automated reordering.",
    },
  ];

  // Benefits of adopting maintenance solutions
  const benefits = [
    {
      image: Icon1,
      title: "Reduced Equipment Downtime",
      bodycopy:
        "Proactive maintenance planning ensures minimal production disruptions.",
    },
    {
      image: Icon1,
      title: "Lower Maintenance Costs",
      bodycopy:
        "Predictive analytics help optimize repair schedules and reduce unnecessary expenses.",
    },
    {
      image: Icon1,
      title: "Increased Machine Lifespan",
      bodycopy:
        "Regular monitoring and timely servicing extend the durability of assets.",
    },
    {
      image: Icon1,
      title: "Improved Safety & Compliance",
      bodycopy:
        "Automated safety checks and maintenance logs ensure adherence to industry standards.",
    },
    {
      image: Icon1,
      title: "Enhanced Efficiency & Productivity",
      bodycopy:
        "Streamlined workflows allow engineers to focus on high-priority tasks efficiently.",
    },
  ];

  return (
    <>
      {/* component displaying banner, features and benefits */}
      <BeneficariesView
        title="Maintenance Engineer"
        features={features}
        benefits={benefits}
      />
    </>
  );
};

export default MaintenanceEngineer;

